import { createFileRoute } from '@tanstack/react-router';
import { useIntl } from 'react-intl';
import { Head } from '@_/components';
import { settingsI18n } from '#src/i18nMessages/index.ts';
import { PersonalInfoSettingsPage } from '#src/pages/Settings/index.ts';

export const Route = createFileRoute('/{-$locale}/_auth/settings_/_layout/personal-info')({
  component: RouteComponent
});

function RouteComponent() {
  const intl = useIntl();

  const title = [
    intl.formatMessage(settingsI18n.personalInfo.heading),
    intl.formatMessage(settingsI18n.accountSettingsHeading)
  ].join(' - ');

  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>
      <PersonalInfoSettingsPage />
    </>
  );
}
